<template>
  <div>
    <div class="row">
      <div class="column">
        <Summary :loanDetails="loanDetails" />
      </div>
      <div class="column">
        <Borrower :borrower="primaryBorrower" />
      </div>
      <div class="column">
        <Borrower :borrower="coBorrower" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { LoanDetails } from "@/models/loans";
import Summary from "@/components/loan/Summary.vue";
import Borrower from "@/components/loan/Borrower.vue";
import { BorrowerTypeIds } from "@/models/loans";
import type { Borrower as BorrowerVM } from "@/models/loans";

const props = defineProps<{
  referenceId: string | undefined;
  loanDetails: LoanDetails;
}>();

const primaryBorrower = computed<BorrowerVM | null>(() => {
  const borrowers = props.loanDetails.borrowers || [];
  if (borrowers && borrowers.length > 0) {
    return (
      borrowers.find(
        (b) => b.borrowerTypeId === BorrowerTypeIds.PrimaryBorrower
      ) || null
    );
  }
  return null;
});

const coBorrower = computed<BorrowerVM | null>(() => {
  const borrowers = props.loanDetails.borrowers || [];
  if (borrowers && borrowers.length > 1) {
    return (
      borrowers.find((b) => b.borrowerTypeId === BorrowerTypeIds.CoBorrower) ||
      null
    );
  }
  return null;
});
</script>

<style scoped>
.row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 0 16px;
}

.column {
  flex: 1;
  min-width: 300px;
}

@media (max-width: 960px) {
  .row {
    gap: 0;
  }
}
</style>
